export const contains = (value: string, substring: string): boolean =>
  value.toUpperCase().replace(/\s/g, ' ').includes(substring.toUpperCase());
